import { useEsalesClickNotifications } from './click-notifications';
import { useEsalesCartNotifications } from './cart-notifications';
import { getDynamicData } from '@avensia/excite';

type Endpoints = 'adding-to-cart' | 'click';

export function useEsalesNotifications() {
  useEsalesClickNotifications();
  useEsalesCartNotifications();
}

export async function notifyEsales(endpoint: Endpoints, ticket: string) {
  const esales = await getDynamicData<Excite.Esales.EsalesApiSettings>().current();
  const url = `${esales.apiBaseUrl}/api/v2/notifications/${endpoint}?esales.market=${esales.market}&esales.customerKey=${esales.customerKey}&esales.sessionKey=${esales.sessionKey}`;

  fetch(url, {
    method: 'post',
    body: JSON.stringify({ ticket }),
  });
}

export * from './facets';

export * from './sort';
